import { RouteButton } from "../../Buttons";
import { GenericTableFactory } from "../../_Shared/Table/Classes/Factory";
/**
 * ### [Route for ('/employee')]
 *
 * Lists all the employees in the database
 *
 */

export function EmployeeList() {
    const table = GenericTableFactory.createEmployeeTable()
    return (
        <>
            <div className="pt-5 pl-5">
                <h1>Employees</h1>
            </div>

            {table.RenderTable()}


            <div className="flex flex-row justify-center gap-3 m-2">
                <RouteButton route={"/main_menu"} text="Back" />
            </div>
        </>
    );
}
